export class SortCompanyModel {
    sortCol: string = "";
    sortType: number = 0;

    //hidecompany
    hidecompany: number = 5;
    companyhideSurrKey: number = 0;

    //badgecompany
    badgecompany: number = 5;
    companybadgeSurrKey: number = 0;

    isEditFeature: boolean = false;
    //qoPhotocompany
    qoPhotocompany: number = 5;

    //dataWareHouse
    dataWareHousecompany: number = 5;

    //activeLocationFeaturecompany
    activeLocationFeaturecompany: number = 5;

    //isAvailable
    isAvailable: number;

    //isHide
    isHide: number;

    //isBadge
    isBadge: number;

    //isActiveLocationOffLimit
    isActiveLocationOffLimit: number;

    //isGeoMap
    isGeoMap: number;

    //isAccessWebhook
    isAccessWebhook: number;

    companySurrkey: number = 0;
    gradecompany: string = "";

}

export class FilterCompanyModel {
    isbadge: string = "";
    country: string = "";
}
